import type { ClientContact, ClientContactDto } from '../types';

export function adaptClientContactDto(dto: ClientContactDto): ClientContact {
  return {
    id: dto.id ?? '',
    name: dto.name ?? '',
    email: dto.email ?? '',
    phone: dto.phone ?? '',
    isPrimary: dto.isPrimary,
    createdAt: dto.createdAt,
  };
}
